import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerBg from "../../images/services-usa/hire_android/hire_android_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service hire-ios-app-developers-banner"
      style={{ backgroundImage: `url(${BannerBg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "0px" }}>
                Hire Best Android App Developers in USA
              </h1>
              <span>Access Full-Cycle, High-End Android App Development</span>
              <p>
                Upscale your business with highly skilled Android app developers
                available for full-time and hybrid roles. Our vetted
                professionals create robust, user-friendly Android applications
                with a keen focus on scalability and user-centric designs. With
                deep expertise in Android frameworks and the latest devices, we
                deliver high-quality, cost-effective solutions that boost your
                project timelines and enhance customer engagement.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="Hire iOS Developers"
              >
                Hire Android App Developer
              </Link>
              <Link
                style={{ border: "2px solid #f47a14" }}
                to="/contact"
                className="border_btn web_case_btn"
                aria-label="Discuss Project Needs"
              >
                Start Your Project
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
